// Opening the sandbox from inside the console (D105): first run's "Explore the sandbox" and the
// scope menu. It mints the session's sandbox token and goes to the sandbox's Overview; the
// caller says why when it cannot.
import { useNavigate } from '@tanstack/react-router'
import { useState } from 'react'
import { isApiError } from '../api/client'
import { startSandbox } from '../sandbox'

export function useOpenSandbox() {
  const navigate = useNavigate()
  const [pending, setPending] = useState(false)
  const [error, setError] = useState<unknown>()
  async function open() {
    setPending(true)
    setError(undefined)
    try {
      const s = await startSandbox()
      await navigate({
        to: '/o/$orgId/p/$projectId/home',
        params: { orgId: s.orgId, projectId: s.projectId },
      })
    } catch (e) {
      setError(e)
    } finally {
      setPending(false)
    }
  }
  return { open, pending, error }
}

/** The message key for a sandbox that did not open: too many at once, or not there. */
export function sandboxErrorKey(error: unknown) {
  return isApiError(error, 429) ? 'sandbox.busy' : 'sandbox.unavailable'
}
